module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(!_vm.editing) ? _c('div', {
    staticClass: "nav-btns"
  }, [_c('router-link', {
    staticClass: "nav-btn prev",
    class: {
      visible: _vm.navIds.prev
    },
    attrs: {
      "to": {
        name: 'card',
        params: {
          deckId: _vm.deckId,
          cardId: _vm.navIds.prev || '0'
        },
        query: _vm.$route.query
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }
  })]), _vm._v(" "), _c('Tooltip', [_vm._v("or press ←")])], 1), _vm._v(" "), _c('span', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "nav-btn next",
    class: {
      visible: _vm.navIds.next
    },
    attrs: {
      "to": {
        name: 'card',
        params: {
          deckId: _vm.deckId,
          cardId: _vm.navIds.next || '0'
        },
        query: _vm.$route.query
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }
  })]), _vm._v(" "), _c('Tooltip', [_vm._v("or press →")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "color-picker"
  }, [_c('span', {
    staticClass: "color",
    class: {
      picked: _vm.eColor === '#ffed96'
    },
    staticStyle: {
      "background-color": "#ffed96"
    },
    on: {
      "click": function($event) {
        _vm.eColor = '#ffed96'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "color",
    class: {
      picked: _vm.eColor === '#adebad'
    },
    staticStyle: {
      "background-color": "#adebad"
    },
    on: {
      "click": function($event) {
        _vm.eColor = '#adebad'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "color",
    class: {
      picked: _vm.eColor === '#ffb399'
    },
    staticStyle: {
      "background-color": "#ffb399"
    },
    on: {
      "click": function($event) {
        _vm.eColor = '#ffb399'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "color",
    class: {
      picked: _vm.eColor === '#bfb3ff'
    },
    staticStyle: {
      "background-color": "#bfb3ff"
    },
    on: {
      "click": function($event) {
        _vm.eColor = '#bfb3ff'
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "markdown-link-container"
  }, [_vm._v("\n    You can use\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet",
      "target": "_blank"
    }
  }, [_vm._v("Markdown")]), _vm._v("\n    to style your text.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.backDefault),
      expression: "backDefault"
    }],
    attrs: {
      "type": "checkbox",
      "id": "backDefaultCb"
    },
    domProps: {
      "checked": Array.isArray(_vm.backDefault) ? _vm._i(_vm.backDefault, null) > -1 : (_vm.backDefault)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.backDefault,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.backDefault = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.backDefault = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.backDefault = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "backDefaultCb"
    }
  }, [_vm._v("Show back first")])]), _vm._v(" "), _c('Cardview', {
    ref: "card",
    staticClass: "cardview",
    attrs: {
      "color": _vm.cardcolor
    }
  }, [(!_vm.editing) ? _c('h1', {
    staticClass: "heading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.card.title))]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "heading-input-container",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eTitle),
      expression: "eTitle"
    }],
    ref: "etitle",
    staticClass: "heading-input",
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.eTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eTitle = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('Markdown', {
    attrs: {
      "slot": "frontContent",
      "source": _vm.card.front
    },
    slot: "frontContent"
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "content-input-container",
    attrs: {
      "slot": "frontContent"
    },
    slot: "frontContent"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eFront),
      expression: "eFront"
    }],
    staticClass: "content-input",
    attrs: {
      "placeholder": "Front Content"
    },
    domProps: {
      "value": (_vm.eFront)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eFront = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "heading",
    attrs: {
      "slot": "headerBack"
    },
    slot: "headerBack"
  }, [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), (!_vm.editing) ? _c('Markdown', {
    attrs: {
      "slot": "backContent",
      "source": _vm.card.back
    },
    slot: "backContent"
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "content-input-container",
    attrs: {
      "slot": "backContent"
    },
    slot: "backContent"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eBack),
      expression: "eBack"
    }],
    staticClass: "content-input",
    attrs: {
      "placeholder": "Back Content"
    },
    domProps: {
      "value": (_vm.eBack)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eBack = $event.target.value
      }
    }
  })]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a71bf272","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = 295
// module chunks = 1